"use strict";

var _context, _context2, _context3, _context4, _context5, _context6, _context7;

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");

var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _util = require("./util");

_forEachInstanceProperty(_context = _Object$keys(_util)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _util[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _util[key];
    }
  });
});

var _history = require("./history");

_forEachInstanceProperty(_context2 = _Object$keys(_history)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _history[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _history[key];
    }
  });
});

var _location = require("./location");

_forEachInstanceProperty(_context3 = _Object$keys(_location)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _location[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _location[key];
    }
  });
});

var _router = require("./router");

_forEachInstanceProperty(_context4 = _Object$keys(_router)).call(_context4, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _router[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _router[key];
    }
  });
});

var _params = require("./params");

_forEachInstanceProperty(_context5 = _Object$keys(_params)).call(_context5, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _params[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _params[key];
    }
  });
});

var _links = require("./links");

_forEachInstanceProperty(_context6 = _Object$keys(_links)).call(_context6, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _links[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _links[key];
    }
  });
});

var _pageLoader = require("./page-loader");

_forEachInstanceProperty(_context7 = _Object$keys(_pageLoader)).call(_context7, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pageLoader[key]) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pageLoader[key];
    }
  });
});